import { Button } from '@shopify/polaris';
import type { ConnectionStatus } from '../types';

// Build-time portal origin (Vite substitutes `import.meta.env.VITE_PORTAL_URL`
// into the bundle during `vite build`). The deploy workflow injects it per
// environment — see `.github/workflows/deploy-shopify-app.yml` and
// `apps/shopify-app/wrangler.jsonc`. Missing env vars must fail loudly rather
// than produce `https://undefined/connectors/<id>`.
const PORTAL_URL = import.meta.env.VITE_PORTAL_URL as string | undefined;
if (!PORTAL_URL) {
  throw new Error('VITE_PORTAL_URL not set at build time');
}

export function PortalButton({
  status,
  connectionId,
}: {
  status: ConnectionStatus;
  connectionId: string;
}) {
  function handleClick() {
    window.open(
      `${PORTAL_URL}/connectors/${connectionId}`,
      '_blank',
      'noopener,noreferrer',
    );
  }

  const label =
    status === 'uninstalled' ? 'Reconnect in Unifd Portal' : 'Open in Unifd Portal';

  return (
    <Button variant="primary" onClick={handleClick}>
      {label}
    </Button>
  );
}
